// @material-ui/core
import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import AppCard from "../../library/card/AppCard";
import CustomerCard from "../../library/card/CustomerCard";
import LicenseCard from "../../library/card/LicenseCard";
import Caba from "../../services/Caba";
import PageHeader from "./PageHeader";

export function withView(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        object: null
      };

      props.toggleLoading(true);
      // make a call
      Caba.get(`/api/v1/${props.slug}/${props.match.params.id}`).then(
        response => {
          const object = response.data;
          this.props.toggleLoading(false);
          this.setState({
            object
          });
        }
      );
    }

    render() {
      // const {location, match} = this.props
      const { object } = this.state;
      const { loading, slug } = this.props;

      let Card;
      if (!loading && object) {
        const cardProps = {
          object,
          key: object.id,
          id: object.id,
          title: object.name ? object.name : object.id
        };
        switch (slug) {
          case "apps":
            Card = <AppCard {...cardProps} {...this.props} slug="apps" />;
            break;

          case "licenses":
            Card = <LicenseCard {...cardProps} slug="licenses" />;
            break;

          case "customers":
            Card = <CustomerCard {...cardProps} slug="customers" />;
            break;

          default:
            break;
        }
      }

      return (
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <PageHeader
              title={`${slug[0].toUpperCase()}${slug.substr(1, slug.length)}`}
            />
          </Grid>

          <Grid item xs={12}>
            {object && Card}
          </Grid>

          <Grid item xs={12}>
            <WrappedComponent {...this.props} />
          </Grid>
        </Grid>
      );
    }
  };
}



// WEBPACK FOOTER //
// ./src/library/pages/withView.js